export const PA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT = 'PA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT'
export const updateCodeInSelectedDisplayProductPA = (code) => ({
  type: PA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT,
  payload: code,
})

export const UPDATE_SUM_ASSURED_AFTER_SELECTED_PLAN_PA = 'UPDATE_SUM_ASSURED_AFTER_SELECTED_PLAN_PA'
export const updateSumAssuredAfterSelectedPlanPA = (sumAssured) => ({
  type: UPDATE_SUM_ASSURED_AFTER_SELECTED_PLAN_PA,
  payload: sumAssured,
})
